import styled from 'styled-components';

export const MainContainer = styled.div``;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;
